import {arrayToMap} from '../functions';

const features = {
    SMS: 'SMS',
    VOICE: 'VOICE',
    MMS: 'MMS',
    SMS_VOICE: 'SMS,VOICE',
    SMS_MMS: 'SMS,MMS',
    VOICE_MMS: 'VOICE,MMS',
    SMS_MMS_VOICE: 'SMS,MMS,VOICE',
};

const featureBaseOptions = [
    {value: features.SMS, label: features.SMS},
    {value: features.VOICE, label: 'Voice'},
    {value: features.MMS, label: features.MMS},
];

const numberTypes = {
    VERIFIED_CLI: 'verified-cli',
    MOBILE_LVN: 'mobile-lvn',
    MOBILE_SHORTCODE: 'mobile-shortcode',
    LANDLINE: 'landline',
    LANDLINE_TOLL_FREE: 'landline-toll-free',
    UNKNOWN: '-unknown-',
};

const featureOptions = [
    {
        value: features.SMS,
        label: 'SMS',
        nameInValidations: 'SMS',
        textOnScreen: 'SMS',
        initialValue: 'SMS',
        nextBestOptions: [features.SMS_VOICE, features.SMS_MMS, features.SMS_MMS_VOICE],
    },
    {
        value: features.VOICE,
        label: 'Voice',
        nameInValidations: 'VOICE',
        textOnScreen: 'Voice',
        initialValue: 'VOICE',
        nextBestOptions: [features.SMS_VOICE, features.VOICE_MMS, features.SMS_MMS_VOICE],
    },
    {
        value: features.SMS_VOICE,
        label: 'SMS & Voice',
        nameInValidations: 'SMS_AND_VOICE',
        textOnScreen: 'SMS & Voice',
        initialValue: 'SMSAndVoice',
        nextBestOptions: [features.SMS_VOICE, features.SMS_MMS, features.SMS_MMS_VOICE],
    },
    {
        value: features.MMS,
        label: 'MMS',
        nameInValidations: 'MMS',
        textOnScreen: 'MMS',
        initialValue: 'MMS',
        nextBestOptions: [features.VOICE_MMS, features.SMS_MMS, features.SMS_MMS_VOICE],
    },
    {
        value: features.SMS_MMS,
        label: 'SMS & MMS',
        nameInValidations: 'SMS_AND_MMS',
        textOnScreen: 'SMS & MMS',
        initialValue: 'SMSAndMMS',
        nextBestOptions: [features.SMS_MMS_VOICE],
    },
    {
        value: features.VOICE_MMS,
        label: 'Voice & MMS',
        nameInValidations: 'VOICE_AND_MMS',
        textOnScreen: 'Voice & MMS',
        initialValue: 'VoiceAndMMS',
        nextBestOptions: [features.SMS_MMS_VOICE],
    },
    {
        value: features.SMS_MMS_VOICE,
        label: 'SMS & MMS & Voice',
        nameInValidations: 'SMS_AND_MMS_AND_VOICE',
        textOnScreen: 'SMS & MMS & Voice',
        initialValue: 'SMSAndMMSAndVoice',
        nextBestOptions: [features.SMS_MMS_VOICE],
    },
];

const typeOptions = [
    {
        value: numberTypes.MOBILE_LVN,
        label: 'Mobile',
        nameInValidations: 'MOBILE',
        textOnScreen: 'Mobile',
        initialValue: numberTypes.MOBILE_LVN,
    },
    {
        value: numberTypes.MOBILE_SHORTCODE,
        label: 'Short code',
        nameInValidations: 'SHORT_CODE',
        textOnScreen: 'Short code',
        initialValue: numberTypes.MOBILE_SHORTCODE,
    },
    {
        value: numberTypes.LANDLINE,
        label: 'Landline',
        nameInValidations: 'LANDLINE',
        textOnScreen: 'Landline',
        initialValue: numberTypes.LANDLINE,
    },
    {
        value: numberTypes.LANDLINE_TOLL_FREE,
        label: 'Toll-free',
        nameInValidations: 'LANDLINE_TOLL_FREE',
        textOnScreen: 'Toll-free',
        initialValue: numberTypes.LANDLINE_TOLL_FREE,
    },
    {
        value: numberTypes.UNKNOWN,
        label: 'Unknown',
        nameInValidations: 'UNKNOWN',
        textOnScreen: 'Unknown',
        initialValue: numberTypes.UNKNOWN,
    },
    {
        value: numberTypes.VERIFIED_CLI,
        label: 'Verified-cli',
        nameInValidations: 'VERIFIED-CLI',
        textOnScreen: 'Verified-cli',
        initialValue: numberTypes.VERIFIED_CLI,
    },
];

const searchPatternOptions = [
    {value: '1', label: 'Contains'},
    {value: '0', label: 'Starts with'},
    {value: '2', label: 'Ends with'},
];
const searchStatusOptions = [
    {value: 'ALL', label: 'All'},
    {value: 'NOT_LINKED', label: 'Not linked'},
    {value: 'LINKED_TO_THIS', label: 'Linked to this campaign'},
    {value: 'LINKED_TO_ANOTHER', label: 'Linked to another campaign'},
];

const validationKeys = {
    TRAFFIC_RESTRICTION: 'TRAFFIC_RESTRICTION',
    COUNTRY_ADDRESS: 'COUNTRY_ADDRESS',
    REGIONAL_ADDRESS: 'REGIONAL_ADDRESS',
    FEATURES_UNAVAILABLE: 'FEATURES_UNAVAILABLE',
    REQUEST_NUMBER: 'REQUEST_NUMBER',
    NEW_REQUEST_NUMBER: 'NEW_REQUEST_NUMBER',
    ANY_COUNTRY: 'ANY_COUNTRY',
};

const buyNumberModalStages = {
    OFF_SCREEN: undefined,
    ADDRESS_FORM: 'ADDRESS_FORM',
    ADDRESS_SUGGESTION: 'ADDRESS_SUGGESTION',
    CONFIRM_ADDRESS: 'CONFIRM_ADDRESS',
    COMFIRM_SPECIAL_VALIDATION: 'COMFIRM_SPECIAL_VALIDATION',
    NEW_REQUEST_NUMBER_FORM: 'NEW_REQUEST_NUMBER_FORM',
    NEW_REQUEST_NUMBER_CONFIRM: 'NEW_REQUEST_NUMBER_CONFIRM',
    BUY_NUMBER_FORM: 'BUY_NUMBER_FORM',
    BUY_NUMBER_CONFIRM: 'BUY_NUMBER_CONFIRM',
};

const specialValidationKeys = {
    INBOUND_ONLY: 'inbound',
    SMS_INBOUND_ONLY: 'SMS inbound',
    VOICE_INBOUND_ONLY: 'voice inbound only',
    P2P_ONLY: 'person-to-person',
    ONE_TO_ONE_SMS_RATIO_ONLY: 'one-to-one',
};

const modalTitles = {
    OFF_SCREEN: '',
    ADDRESS_FORM: 'Your details',
    REQUEST_ADDRESS_FORM: 'Request number',
    ADDRESS_SUGGESTION: 'Confirm address',
    REQUEST_ADDRESS_SUGGESTION: 'Confirm address',
    CONFIRM_ADDRESS: 'Confirm purchase',
    REQUEST_CONFIRM_ADDRESS: 'Submit request',
    COMFIRM_SPECIAL_VALIDATION: 'Confirm purchase',
    NEW_REQUEST_NUMBER_FORM: 'Request new numbers',
    NEW_REQUEST_NUMBER_CONFIRM: 'Submit request',
    BUY_NUMBER_FORM: 'Confirm purchase',
    INITIAL_REQUEST_ADDRESS_FORM: 'Request number',
    INITIAL_REQUEST_NEW_NUMBER_FORM: 'Request new numbers',
};

const errors = {
    EMPTY_ERROR: "You can't leave this empty",
    TERMS_AND_AGREEMENTS_ERROR: 'You need to accept the Terms of service',
    REQUIRED_API_KET_ERROR: 'You have multiple API keys, please choose which one this Number should be assigned to.',
    NUMBERS_TYPE_ERROR: 'Please enter a valid number.',
    FEATURE_ERROR: 'Please select one or more features.',
    FIFTY_CHAR_LIMIT: 'should not be more than 50 characters',
    USE_CASE_CHAR_LIMIT: 'should not be more than 250 characters',
    POSTCODE_CHAR_LIMIT: 'should not be more than 12 characters',
    POSTCODE_VALID: 'Enter a valid zip/postcode',
    NO_PLUS_IN_NUMBER: 'Number cannot include +',
};

const tooltipsText = {
    REGIONAL_RESTRICTION_TOWN: 'The town/city must be from the same region as the area code of this number.',
};

const trafficStage = {
    name: buyNumberModalStages.COMFIRM_SPECIAL_VALIDATION,
    title: modalTitles.COMFIRM_SPECIAL_VALIDATION,
};
const addressConfirmationStages = [
    {name: buyNumberModalStages.ADDRESS_FORM, title: modalTitles.ADDRESS_FORM},
    {name: buyNumberModalStages.ADDRESS_SUGGESTION, title: modalTitles.ADDRESS_SUGGESTION},
    {name: buyNumberModalStages.CONFIRM_ADDRESS, title: modalTitles.CONFIRM_ADDRESS},
];
const directBuyNumberStages = [{name: buyNumberModalStages.BUY_NUMBER_FORM, title: modalTitles.BUY_NUMBER_FORM}];

const featuresTextOnScreenMap = arrayToMap(featureOptions, 'textOnScreen');
const typesTextOnScreenMap = arrayToMap(typeOptions, 'textOnScreen');
const featuresInitialValueMap = arrayToMap(featureOptions, 'initialValue');
const typesInitialValueMap = arrayToMap(typeOptions, 'initialValue');
const typeOptionsValueToOptionMap = arrayToMap(typeOptions, 'value');
const featuresOptionsValueToOptionMap = arrayToMap(featureOptions, 'value');
const numbersStatusToolTipText = {
    LINKED: "This number is linked to the campaign and able to send SMS",
    UNLINKED: "Waiting for the campaign to be ACTIVE. It will be linked automatically afterward. If the campaign is active, press the 'Sync Numbers' button to sync it",
    PROVIDER_CANNOT_BE_DETERMINE: "The number encountered an issue, and we couldn't determine whether it belongs to Vonage API or Inteliquent. Press the 'Sync Numbers' button for resolution.",
    PROVIDER_UNKNOWN: "The number was just added to our DB. It will undergo an internal process",
    APPROVED: "This number is linked to the campaign and able to send SMS",
    REJECTED: "The number had a problem in the registration process. Press the 'Sync Numbers'' button",
    WAITING_FOR_VERIFIED_CAMPAIGN: "Waiting for the campaign to be ACTIVE. It will be linked once the campaign is verified",
    WAITING_FOR_MIGRATION: "The number is waiting to be migrated from Inteliquent TO Vonage API. Can take 1-3 days",
    MIGRATION_FAILURE: "The number was unable to migrate to Vonage API. Please contact the support team(Numbers Team)",
    MIGRATION_SUCCESS: "The number was Migrated successfully to Vonage API",
    MIGRATION_PENDING: "The number is waiting to be migrated from Inteliquent to Vonage API. Can take 1-3 days",
    WAITING_FOR_NUMBER_POOLING: "The account has more than 50 numbers. Number pooling process was activated and waiting to be approved. This can take a few weeks",
    UNASSIGNED: "The number was removed from extension and is not able to send messages",
    NOT_SMSABLE: "The number cannot send messages and will be deleted from the account in 1 day",
    WAITING_FOR_UNLINK: "The number got some error in the registration process and will be unlinked and linked again automatically",
    NEED_TO_BE_LINKED_AGAIN: "The number got some error in the registration process and will be linked again automatically",
    UNLINKING: "The number got some error in the registration process and will be unlinked and linked again automatically",
    LINKING: "The number is being verified for approval on Vonage API",
    FOLLOWER_NEED_TO_BE_LINKED: "The number is on a child account and is waiting for the main account to be approved"
};


export {
    errors,
    modalTitles,
    specialValidationKeys,
    buyNumberModalStages,
    typeOptionsValueToOptionMap,
    validationKeys,
    featuresOptionsValueToOptionMap,
    searchPatternOptions,
    searchStatusOptions,
    featuresTextOnScreenMap,
    typesTextOnScreenMap,
    featuresInitialValueMap,
    typesInitialValueMap,
    typeOptions,
    featureOptions,
    trafficStage,
    addressConfirmationStages,
    directBuyNumberStages,
    tooltipsText,
    features,
    featureBaseOptions,
    numberTypes,
    numbersStatusToolTipText
};
